export default "__VITE_ASSET__Doc0b7Op__ 400w, __VITE_ASSET___jBookxv__ 800w, __VITE_ASSET__Bf_eczOp__ 1200w";